
/* ---------- Hero: map, ZIP lookup, arcs, zoom and the quote flow ---------- */
(function(){
  var root = document.querySelector('.hv-c');
  if(!root) return;
  /* y: yards [id, x, y]; c: counties {fips: [name, x, y]}; t: towns [name, x, y, fips]. Map units = svg viewBox. */
  var D = {"y":[["tc",542.9,482.4,41.264,-73.9868],["bb",448.2,401.6,41.5559,-74.439],["mm",540.5,267.2,42.0376,-73.991],["ww",515.9,553,41.0107,-74.1179],["wb",415.5,343.4,41.7654,-74.5963],["eb",304.3,280.2,41.9914,-75.134]],"c":{"34003":["Bergen",525.1,567.1,"NJ"],"34013":["Essex",489.4,615.8,"NJ"],"34017":["Hudson",525.4,629,"NJ"],"34027":["Morris",426.2,594.6,"NJ"],"34031":["Passaic",477.4,546.3,"NJ"],"34037":["Sussex",395.8,517.6,"NJ"],"34039":["Union",476.1,650.6,"NJ"],"36001":["Albany",543.1,110.7,"NY"],"36005":["Bronx",570.8,596.8,"NY"],"36007":["Broome",163.3,231.9,"NY"],"36017":["Chenango",207.1,139.9,"NY"],"36021":["Columbia",613.9,207.5,"NY"],"36025":["Delaware",339.1,223,"NY"],"36027":["Dutchess",592.6,342.9,"NY"],"36039":["Greene",512.6,200.8,"NY"],"36047":["Kings",554,655.7,"NY"],"36059":["Nassau",628.4,627.8,"NY"],"36061":["New York",547.5,618.4,"NY"],"36071":["Orange",475.8,444.5,"NY"],"36077":["Otsego",326,101.5,"NY"],"36079":["Putnam",591.9,437.1,"NY"],"36081":["Queens",578.8,638.3,"NY"],"36083":["Rensselaer",638,79.1,"NY"],"36085":["Richmond",509.3,671.3,"NY"],"36087":["Rockland",535.4,513.3,"NY"],"36093":["Schenectady",525.1,50.5,"NY"],"36095":["Schoharie",446.8,114.8,"NY"],"36103":["Suffolk",783.4,588.7,"NY"],"36105":["Sullivan",379.8,356.9,"NY"],"36107":["Tioga",63.1,227.2,"NY"],"36111":["Ulster",485.6,309.1,"NY"],"36119":["Westchester",591.7,510.7,"NY"],"42069":["Lackawanna",204.2,433.4,"PA"],"42079":["Luzerne",124,504.4,"PA"],"42089":["Monroe",259.6,539.4,"PA"],"42095":["Northampton",266,623.8,"PA"],"42103":["Pike",324.1,463.8,"PA"],"42115":["Susquehanna",165.8,326.2,"PA"],"42127":["Wayne",268.5,375.6,"PA"],"42131":["Wyoming",119.5,409.7,"PA"]},"p":{"k":15938.7252,"tx":414.725,"ty":12958.72}};
  /* ---------- LEAD INTEGRATION (WordPress port: POST <restUrl>lead, was the GHL webhook) ----------
     Posts a partial lead at each step and the full lead on submit. Payload keys:
     {zip, address, fulfillment, product, tonnage, name, phone, email, partial:'address'|'product'|false, utm_source, utm_medium, utm_campaign, utm_term, utm_content}
     plus hp:'' (honeypot). address is the delivery address when one is typed, else "<Town>, <State> <ZIP>" from the postcode lookup, else the ZIP.
     product is the salt's display name (e.g. "Aden Rock Salt"). */
  /* ---------- ZIP INTEGRATION (WordPress port: GET <restUrl>geocode?zip=, was Geoapify) ---------- */
  /* window.adensalt.restUrl is emitted by enqueue-scripts.php before this bundle; the absolute default covers a missing inline script */
  function restUrl(){ return String(window.adensalt && window.adensalt.restUrl ? window.adensalt.restUrl : '/wp-json/adensalt/v1/').replace(/\/?$/, '/'); }
  var YARD_NAMES = {tc:'Tomkins Cove Marine Terminal', bb:'Bloomingburg', mm:'Mt Marion', ww:'Waldwick', wb:'Woodbourne', eb:'East Branch'};
  /* WordPress port: editable copy published by hero.php as data-* on #hero; the literals above/below stay as the fallbacks */
  function esc(s){ return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  try{
    var yn = JSON.parse(root.getAttribute('data-yard-names') || '{}');
    Object.keys(YARD_NAMES).forEach(function(k){ if(yn && typeof yn[k] === 'string' && yn[k].trim()) YARD_NAMES[k] = yn[k].trim(); });
  }catch(err){ /* keep the literals */ }
  var ZIP_NOTE = root.getAttribute('data-zip-note') || 'Aden sales rep will get back to you promptly.';
  var PHONE_A = '<a href="tel:' + ((root.getAttribute('data-phone-dial') || '').replace(/\D+/g, '') || '8459907625') + '">' + esc(root.getAttribute('data-phone-short') || '845-990-ROCK (7625)') + '</a>';
  /* WordPress addition: hero.php prints either the one-screen form (data-role="quote") or the original steps. The ZIP
     lookup, the map, the lead post and "Received." are shared; the steps' own handlers run only when the steps are there. */
  var single = root.querySelector('[data-role="quote"]');
  var form = single || root.querySelector('[data-role="step1form"]');
  var input = form.querySelector('input[name="zip"]');
  var svg = root.querySelector('.hv-c__svg');
  var hit = svg.querySelector('.hv-c__hit');
  var spot = svg.querySelector('.hv-c__spot');
  var live = root.querySelector('[data-role="live"]');
  var pins = {};
  root.querySelectorAll('.hv-c__pin').forEach(function(p){ pins[p.getAttribute('data-y')] = p; });
  /* ---------- ZIP lookup ----------
     Five digits typed: a debounced postcode lookup (the theme's geocode route) gives lat/lon, county and state. The county is matched
     against the 40 territory counties (by name and state, else by where the point falls on the map). Inside: the county
     lights, the marker drops and a line runs to the nearest yard (straight-line miles). Outside: a call-us line.
     Any network failure is silent: no highlight, and Get my price still works. */
  var R = Math.PI / 180;
  var PROJ = (function(){
    var t = function(y){ return Math.tan((Math.PI / 2 + y) / 2); }, p0 = 40.5 * R, p1 = 42.5 * R;
    var n = Math.log(Math.cos(p0) / Math.cos(p1)) / Math.log(t(p1) / t(p0)), f = Math.cos(p0) * Math.pow(t(p0), n) / n;
    return function(lat, lon){
      var L = (lon + 74.6) * R, r = f / Math.pow(t(lat * R), n);
      return [D.p.tx + D.p.k * r * Math.sin(n * L), D.p.ty - D.p.k * (f - r * Math.cos(n * L))];
    };
  })();
  function miles(a1, o1, a2, o2){
    var h = Math.pow(Math.sin((a2 - a1) * R / 2), 2) + Math.cos(a1 * R) * Math.cos(a2 * R) * Math.pow(Math.sin((o2 - o1) * R / 2), 2);
    return 3958.8 * 2 * Math.asin(Math.sqrt(h));
  }
  function cleanCounty(s){ return String(s || '').toLowerCase().replace(/\s+(county|borough|parish)$/, '').replace(/[^a-z]+/g, ' ').trim(); }
  function findCounty(res, x, y){
    var name = cleanCounty(res.county), st = String(res.state_code || '').toUpperCase(), hitF = null;
    if(name){
      Object.keys(D.c).forEach(function(f){ if(cleanCounty(D.c[f][0]) === name && D.c[f][3] === st) hitF = f; });
      if(hitF) return hitF;
    }
    var pt = svg.createSVGPoint(); pt.x = x; pt.y = y;
    svg.querySelectorAll('.hv-c__c').forEach(function(c){ if(!hitF && c.isPointInFill(pt)) hitF = c.getAttribute('data-f'); });
    return hitF;
  }
  var current = null;
  function clear(){
    current = null;
    root.classList.remove('has-hit');
    Object.keys(pins).forEach(function(k){ pins[k].classList.remove('is-near'); });
    live.textContent = '';
    arcsClear();
    yardLayout();
  }
  function show(p){
    if(current && current.k === p.k) return;
    current = p;
    var county = svg.querySelector('.hv-c__c[data-f="' + p.f + '"]');
    hit.setAttribute('d', county ? county.getAttribute('d') : '');
    var near = p.near;
    Object.keys(pins).forEach(function(k){ pins[k].classList.toggle('is-near', k === near[0]); });
    spot.setAttribute('cx', p.x); spot.setAttribute('cy', p.y);
    root.classList.add('has-hit');
    arcsZip(p);
    yardLayout();
  }
  /* zip state: '' (nothing yet), 'in', 'out', 'err' (bad entry on submit) */
  var zipState = '', zipInfo = null, zipSeq = 0, zipCache = {};
  var PIN_SVG = '<svg class="si-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.2 C12 21.2 5.4 15.6 5.4 10.1 A6.6 6.6 0 0 1 18.6 10.1 C18.6 15.6 12 21.2 12 21.2 Z"/><circle cx="12" cy="10" r="2.4"/></svg>';
  function zipLine(){
    if(zipState === 'err') return '<span class="si-err">Enter a 5-digit ZIP code.</span>';
    if(zipState === 'in') return PIN_SVG + '<span>Nearest yard: ' + esc(YARD_NAMES[zipInfo.near[0]]) + ', about ' + zipInfo.mi + ' miles.</span>';
    if(zipState === 'out') return '<span>That ZIP is outside our usual service area. Call ' + PHONE_A + ' and we\'ll see what we can do.</span>';
    return ZIP_NOTE;
  }
  function setZip(state, info){
    zipState = state; zipInfo = info || null;
    /* on the one screen the ZIP is checked with the other fields (fieldState) */
    if(!single) input.setAttribute('aria-invalid', state === 'err' ? 'true' : 'false');
    if(step === 1){
      stepText.innerHTML = zipLine();
      stepText.classList.toggle('is-zip', state === 'in' || state === 'out');
      stepText.classList.toggle('is-err', state === 'err');
    }
    if(state === 'in') live.textContent = 'Nearest yard: ' + YARD_NAMES[info.near[0]] + '.';
  }
  function applyZip(z, res){
    if(z !== input.value) return;
    if(!res){ clear(); setZip(''); return; }
    var xy = PROJ(res.lat, res.lon), f = findCounty(res, xy[0], xy[1]);
    if(!f){ clear(); setZip('out'); return; }
    var near = null, nd = Infinity;
    D.y.forEach(function(y){ var d = miles(res.lat, res.lon, y[3], y[4]); if(d < nd){ nd = d; near = y; } });
    var info = {k:z, x:+xy[0].toFixed(1), y:+xy[1].toFixed(1), f:f, near:near, mi:Math.max(1, Math.round(nd))};
    show(info);
    setZip('in', info);
  }
  function lookup(z){
    if(z in zipCache){ applyZip(z, zipCache[z]); return; }
    if(!window.fetch) return;
    var seq = ++zipSeq;
    fetch(restUrl() + 'geocode?zip=' + z)
      .then(function(r){ if(r.status === 404) return null; if(!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(g){
        /* {zip,lat,lon,city,state_code,county} -> the one-result shape the code below expects; a 404 is an empty list */
        var j = {results: g && typeof g.lat === 'number' ? [{lat:g.lat, lon:g.lon, county:g.county || '', state_code:g.state_code || '', city:g.city || '', postcode:String(g.zip || z), country_code:'us'}] : []};
        var res = (j.results || []).filter(function(r){ return r.country_code === 'us' && typeof r.lat === 'number'; });
        var exact = res.filter(function(r){ return String(r.postcode || '').slice(0, 5) === z; });
        zipCache[z] = exact[0] || res[0] || null;
        if(seq === zipSeq) applyZip(z, zipCache[z]);
      })
      .catch(function(){ /* silent: no highlight */ });
  }
  var timer = null;
  input.addEventListener('input', function(){
    var v = input.value.replace(/\D+/g, '').slice(0, 5);
    if(v !== input.value) input.value = v;
    clearTimeout(timer);
    zipSeq++;
    if(v.length < 5){ if(current) clear(); if(zipState) setZip(''); return; }
    timer = setTimeout(function(){ lookup(v); }, 250);
  });
  /* ---------- County labels ----------
     Hover (fine pointers) or keyboard focus shows a county's name in a small label anchored at that county's
     label point; it never follows the pointer. Click, tap, or Enter pins it; the same county again, a click
     elsewhere, or Escape clears. A typed match is separate state: its highlight, nearest yard and line stay put
     while other counties are hovered, and the pinned label returns when the pointer leaves. */
  var map = root.querySelector('.hv-c__map');
  var group = svg.querySelector('.hv-c__cs');
  var sel = svg.querySelector('.hv-c__sel');
  var ring = svg.querySelector('.hv-c__ring');
  var tip = root.querySelector('.hv-c__tip');
  var paths = Array.prototype.slice.call(group.querySelectorAll('.hv-c__c'));
  var STATES = {NY:'New York', NJ:'New Jersey', PA:'Pennsylvania'};
  var RANK = {core:0, extended:1, edge:2};
  var vb = svg.viewBox.baseVal;
  var keyOrder = paths.slice().sort(function(a, b){
    return (RANK[a.getAttribute('data-t')] - RANK[b.getAttribute('data-t')]) ||
      a.getAttribute('data-n').localeCompare(b.getAttribute('data-n'));
  });
  var rover = keyOrder[0], hovered = null, focused = null, pinned = null, shown = null;
  svg.setAttribute('role', 'group');
  /* the svg itself is not a tab stop; its counties are (one stop, arrows rove) */
  svg.setAttribute('tabindex', '-1');
  paths.forEach(function(p){
    p.setAttribute('role', 'button');
    p.setAttribute('tabindex', p === rover ? '0' : '-1');
    p.setAttribute('aria-pressed', 'false');
    p.setAttribute('aria-label', p.getAttribute('data-n') + ' County, ' + (STATES[p.getAttribute('data-s')] || p.getAttribute('data-s')));
  });
  root.classList.add('is-live');
  function isFocusVisible(el){ try{ return el.matches(':focus-visible'); }catch(err){ return true; } }
  /* Label placement. Everything is measured in the hero's own box (plus its scroll offset, in case a browser
     without overflow:clip lets it scroll). The label must not cover the headline, sub, form or legend, and
     should not cover a yard pin, a yard name, the Tomkins Cove Marine Terminal ring or its caption. It tries above the
     anchor, then below, then nudged sideways, then to the right or left of it, and takes the first clear spot. */
  var anchors = {};
  function box(r, rr, pad){ pad = pad || 0; return [r.left - rr.left - pad, r.top - rr.top - pad, r.right - rr.left + pad, r.bottom - rr.top + pad]; }
  function copyBoxes(rr){
    var out = [];
    ['.hv-c__h1', '.hv-c__sub', '.form-wrap', '.hv-c__legend', '.hv-c__boxes'].forEach(function(s){
      var el = root.querySelector(s);
      if(!el) return;
      var b = box(el.getBoundingClientRect(), rr, 6);
      /* the headline does not wrap on desktop, so its text can run past its own box */
      try{
        var g = document.createRange(); g.selectNodeContents(el);
        var t = g.getBoundingClientRect();
        if(t.width) b = [Math.min(b[0], t.left - rr.left - 6), Math.min(b[1], t.top - rr.top - 6), Math.max(b[2], t.right - rr.left + 6), Math.max(b[3], t.bottom - rr.top + 6)];
      }catch(err){}
      out.push(b);
    });
    return out;
  }
  function markBoxes(rr){
    var out = [];
    root.querySelectorAll('.hv-c__name').forEach(function(n){
      if(parseFloat(getComputedStyle(n).opacity) > 0.1) out.push(box(n.getBoundingClientRect(), rr, 4));
    });
    root.querySelectorAll('.hv-c__dot').forEach(function(d){ out.push(box(d.getBoundingClientRect(), rr, 4)); });
    var main = root.querySelector('.hv-c__pin--main');
    if(main){ var c = main.getBoundingClientRect(); out.push([c.left - rr.left - 23, c.top - rr.top - 23, c.left - rr.left + 23, c.top - rr.top + 23]); }
    var lead = root.querySelector('.hv-c__lead');
    if(lead){ var l = lead.getBoundingClientRect(); if(l.width) out.push(box(l, rr, 3)); }
    if(root.classList.contains('has-hit')) out.push(box(spot.getBoundingClientRect(), rr, 3));
    return out;
  }
  function inBox(x, y, b){ return x > b[0] && x < b[2] && y > b[1] && y < b[3]; }
  /* The county's label point, or when that sits under the copy or off the hero, the middle of the part people can see */
  function anchorOf(p, rr, mr, blocks, m){
    var sx = mr.width / vb.width, sy = mr.height / vb.height, ox = mr.left - rr.left, oy = mr.top - rr.top;
    var ax = ox + (parseFloat(p.getAttribute('data-ax')) - vb.x) * sx;
    var ay = oy + (parseFloat(p.getAttribute('data-ay')) - vb.y) * sy;
    function hidden(x, y){ return x < m || x > rr.width - m || y < m || y > rr.height - m || blocks.some(function(b){ return inBox(x, y, b); }); }
    if(!hidden(ax, ay)) return [ax, ay];
    var key = p.getAttribute('data-f');
    if(key in anchors) return anchors[key];
    var bb = p.getBBox(), pt = svg.createSVGPoint(), pts = [], N = 24;
    for(var i = 0; i < N; i++) for(var j = 0; j < N; j++){
      pt.x = bb.x + bb.width * (i + .5) / N; pt.y = bb.y + bb.height * (j + .5) / N;
      if(!p.isPointInFill(pt)) continue;
      var x = ox + (pt.x - vb.x) * sx, y = oy + (pt.y - vb.y) * sy;
      if(!hidden(x, y)) pts.push([x, y]);
    }
    var best = null;
    if(pts.length){
      var cx = 0, cy = 0;
      pts.forEach(function(q){ cx += q[0]; cy += q[1]; });
      cx /= pts.length; cy /= pts.length;
      var bd = Infinity;
      pts.forEach(function(q){ var d = Math.hypot(q[0] - cx, q[1] - cy); if(d < bd){ bd = d; best = q; } });
    }
    anchors[key] = best;
    return best;
  }
  function place(){
    if(!shown) return;
    var rr = root.getBoundingClientRect(), mr = map.getBoundingClientRect();
    var W = rr.width, H = rr.height, w = tip.offsetWidth, h = tip.offsetHeight, gap = 10, m = 12;
    var top0 = (parseFloat(getComputedStyle(root).getPropertyValue('--hdr')) || 0) + m;
    var blocks = copyBoxes(rr), marks = markBoxes(rr);
    var a = anchorOf(shown, rr, mr, blocks, m);
    if(!a){ tip.classList.remove('is-on'); return; }
    var ax = a[0], ay = a[1];
    function ov(r, b){ return Math.max(0, Math.min(r[2], b[2]) - Math.max(r[0], b[0])) * Math.max(0, Math.min(r[3], b[3]) - Math.max(r[1], b[1])); }
    function cost(l, t){
      var r = [l, t, l + w, t + h], c = 0;
      if(l < m || t < top0 || l + w > W - m || t + h > H - m) c += 1e7;
      blocks.forEach(function(b){ c += ov(r, b) * 100; });
      marks.forEach(function(b){ c += ov(r, b); });
      return c;
    }
    var cands = [], steps = [0], s;
    for(s = 14; s <= w / 2; s += 14) steps.push(s, -s);
    steps.forEach(function(dx){
      [['up', ay - h - gap], ['down', ay + gap]].forEach(function(v){
        var l = Math.max(m, Math.min(ax - w / 2 + dx, W - w - m)), cx = ax - l;
        if(cx >= 12 && cx <= w - 12) cands.push({pos:v[0], l:l, t:v[1], k:cx});
      });
    });
    [0, 8, -8, h / 2 - 12, 12 - h / 2].forEach(function(dy){
      var t = ay - h / 2 + dy;
      cands.push({pos:'right', l:ax + gap, t:t, k:ay - t});
      cands.push({pos:'left', l:ax - w - gap, t:t, k:ay - t});
    });
    var pick = null, low = Infinity;
    for(var i = 0; i < cands.length; i++){
      var c = cost(cands[i].l, cands[i].t);
      if(c === 0){ pick = cands[i]; break; }
      if(c < low){ low = c; pick = cands[i]; }
    }
    tip.classList.toggle('is-below', pick.pos === 'down');
    tip.classList.toggle('is-right', pick.pos === 'right');
    tip.classList.toggle('is-left', pick.pos === 'left');
    tip.style.left = Math.round(pick.l + root.scrollLeft) + 'px';
    tip.style.top = Math.round(pick.t + root.scrollTop) + 'px';
    tip.style.setProperty(pick.pos === 'up' || pick.pos === 'down' ? '--cx' : '--cy', Math.round(pick.k) + 'px');
    return true;
  }
  function render(){
    var want = hovered || focused || pinned;
    paths.forEach(function(p){ p.classList.toggle('is-hov', p === hovered || p === focused); });
    if(want !== shown){
      shown = want;
      if(want){
        tip.textContent = want.getAttribute('data-n') + ' County, ' + want.getAttribute('data-s');
        tip.classList.toggle('is-on', !!place());
      }else{
        tip.classList.remove('is-on');
      }
    }
  }
  function pin(p){
    if(pinned){ pinned.classList.remove('is-pin'); pinned.setAttribute('aria-pressed', 'false'); }
    pinned = p;
    if(p){
      p.classList.add('is-pin');
      p.setAttribute('aria-pressed', 'true');
      sel.setAttribute('d', p.getAttribute('d'));
    }
    root.classList.toggle('has-pin', !!p);
    render();
  }
  function setRover(p){
    if(p === rover) return;
    rover.setAttribute('tabindex', '-1');
    p.setAttribute('tabindex', '0');
    rover = p;
  }
  function syncRing(){
    var a = document.activeElement;
    var on = !!(a && a.parentNode === group && isFocusVisible(a));
    if(on) ring.setAttribute('d', a.getAttribute('d'));
    root.classList.toggle('has-ring', on);
    focused = on ? a : null;
    render();
  }
  function countyOf(t){ return t && t.closest ? t.closest('.hv-c__c') : null; }
  group.addEventListener('pointerover', function(e){
    if(e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    var p = countyOf(e.target);
    if(p && p !== hovered){ hovered = p; render(); }
  });
  group.addEventListener('pointerout', function(e){
    if(!hovered) return;
    var to = countyOf(e.relatedTarget);
    if(to && group.contains(to)) return;
    hovered = null; render();
  });
  document.addEventListener('click', function(e){
    var p = countyOf(e.target);
    if(p && group.contains(p)){ setRover(p); pin(p === pinned ? null : p); }
    else if(pinned){ pin(null); }
  });
  svg.addEventListener('keydown', function(e){
    var p = e.target;
    if(!p || p.parentNode !== group) return;
    var k = e.key, n = keyOrder.length, i = keyOrder.indexOf(p), to = null;
    if(k === 'ArrowRight' || k === 'ArrowDown') to = keyOrder[(i + 1) % n];
    else if(k === 'ArrowLeft' || k === 'ArrowUp') to = keyOrder[(i - 1 + n) % n];
    else if(k === 'Home') to = keyOrder[0];
    else if(k === 'End') to = keyOrder[n - 1];
    if(to){ e.preventDefault(); setRover(to); try{ to.focus({preventScroll:true}); }catch(err){ to.focus(); } syncRing(); return; }
    if(k === 'Enter' || k === ' ' || k === 'Spacebar'){ e.preventDefault(); pin(p === pinned ? null : p); }
    /* Escape clears the pin only; focus stays on the county so keyboard users keep their place */
    else if(k === 'Escape'){ if(pinned){ e.preventDefault(); pin(null); } }
  });
  svg.addEventListener('focusin', syncRing);
  svg.addEventListener('focusout', function(){ setTimeout(syncRing, 0); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && pinned && !svg.contains(e.target)) pin(null); });
  function relayout(){ arcsResize(); anchors = {}; yardLayout(); if(shown) tip.classList.toggle('is-on', !!place()); }
  if('ResizeObserver' in window){ new ResizeObserver(relayout).observe(root); }
  else{ window.addEventListener('resize', relayout, {passive:true}); }
  /* ---------- Yard names in the typed state ----------
     The typed place's marker stays where the place really is. Instead, each yard name (nearest yard first) takes the
     first clear spot around its own dot: its usual side, the other side, above, then below. Clear means off the
     marker, the line to the nearest yard, the other dots and names, and the copy; a spot off the highlighted county
     wins a tie. Tomkins Cove Marine Terminal only swaps sides. At rest nothing moves. */
  function toMap(rr, mr){
    var sx = mr.width / vb.width, sy = mr.height / vb.height, ox = mr.left - rr.left, oy = mr.top - rr.top;
    return {
      px: function(x, y){ return [ox + (x - vb.x) * sx, oy + (y - vb.y) * sy]; },
      svg: function(x, y){ var q = svg.createSVGPoint(); q.x = vb.x + (x - ox) / sx; q.y = vb.y + (y - oy) / sy; return q; }
    };
  }
  function area(a, b){ return Math.max(0, Math.min(a[2], b[2]) - Math.max(a[0], b[0])) * Math.max(0, Math.min(a[3], b[3]) - Math.max(a[1], b[1])); }
  function nameBox(p, rr){
    var n = p.querySelector('.hv-c__name'), b = n.querySelector('b'), sm = n.querySelector('small');
    var r = box(b.getBoundingClientRect(), rr, 0);
    if(sm && getComputedStyle(sm).getPropertyValue('--vis').trim() !== '0'){
      var q = box(sm.getBoundingClientRect(), rr, 0);
      r = [Math.min(r[0], q[0]), Math.min(r[1], q[1]), Math.max(r[2], q[2]), Math.max(r[3], q[3])];
    }
    var lead = p.querySelector('.hv-c__lead');
    if(lead){ var l = lead.getBoundingClientRect(); if(l.width){ l = box(l, rr, 2); r = [Math.min(r[0], l[0]), Math.min(r[1], l[1]), Math.max(r[2], l[2]), Math.max(r[3], l[3])]; } }
    return r;
  }
  function yardLayout(){
    var list = Object.keys(pins).map(function(k){ return pins[k]; });
    list.forEach(function(p){ p.removeAttribute('data-alt'); });
    if(!current) return;
    var rr = root.getBoundingClientRect(), T = toMap(rr, map.getBoundingClientRect());
    var W = rr.width, H = rr.height, top0 = (parseFloat(getComputedStyle(root).getPropertyValue('--hdr')) || 0) + 4;
    var blocks = copyBoxes(rr);
    var spotBox = box(spot.getBoundingClientRect(), rr, 7);
    var seg = [];
    if(zipArc) zipArc.pts.forEach(function(q){ seg.push(T.px(q[0], q[1])); });
    var dots = list.map(function(p){
      var c = p.getBoundingClientRect(), x = c.left - rr.left, y = c.top - rr.top;
      var r = p.classList.contains('hv-c__pin--main') ? 23 : 12;
      return {p:p, b:[x - r, y - r, x + r, y + r]};
    });
    var order = list.slice().sort(function(a, b){
      function rank(p){ return p.classList.contains('is-near') ? 0 : p.classList.contains('hv-c__pin--main') ? 1 : 2; }
      return rank(a) - rank(b);
    });
    var placed = [];
    order.forEach(function(p){
      var name = p.querySelector('.hv-c__name');
      if(getComputedStyle(name).getPropertyValue('--vis').trim() === '0') return;
      var main = p.classList.contains('hv-c__pin--main');
      var opts = main ? ['', 'l', 'r'] : ['', 'r', 'l', 't', 'b'];
      var pick = '', pickBox = null, low = Infinity;
      opts.forEach(function(alt, k){
        if(alt) p.setAttribute('data-alt', alt); else p.removeAttribute('data-alt');
        var r = nameBox(p, rr), c = !k ? 0 : (alt === 't' || alt === 'b') ? 220 : 140;
        if(r[0] < 8 || r[1] < top0 || r[2] > W - 8 || r[3] > H - 8) c += 1e6;
        blocks.forEach(function(b){ c += area(r, b) * 100; });
        c += area(r, spotBox) * 40;
        var rp = [r[0] - 3, r[1] - 3, r[2] + 3, r[3] + 3];
        seg.forEach(function(q){ if(inBox(q[0], q[1], rp)) c += 80; });
        dots.forEach(function(d){ if(d.p !== p) c += area(r, d.b) * 20; });
        placed.forEach(function(b){ c += area(r, b) * 20; });
        /* share of the name sitting on the highlighted county */
        var on = 0;
        for(var u = 0; u < 6; u++) for(var v = 0; v < 3; v++){
          if(hit.isPointInFill(T.svg(r[0] + (r[2] - r[0]) * (u + .5) / 6, r[1] + (r[3] - r[1]) * (v + .5) / 3))) on++;
        }
        c += on / 18 * 300;
        if(c < low){ low = c; pick = alt; pickBox = r; }
      });
      if(pick) p.setAttribute('data-alt', pick); else p.removeAttribute('data-alt');
      placed.push([pickBox[0] - 4, pickBox[1] - 4, pickBox[2] + 4, pickBox[3] + 4]);
    });
  }
  /* ---------- Guided flow ----------
     1 ZIP, 2 salt (one or both, then Continue), 3 deliver or pick up plus tonnage, 4 contact, 5 confirmation. Steps 2 to 4
     share one layout: title, one-line subtitle, two cards, Back at the bottom left; the shell animates to each step's height. Each step posts a partial lead to the lead route (same keys as
     the live page, plus zip); the final post goes only once name, phone and email are valid. */
  var shell = root.querySelector('.form-panel-shell');
  var stepText = root.querySelector('.step-indicator');
  var panels = {};
  shell.querySelectorAll('.form-panel').forEach(function(p){ panels[p.getAttribute('data-step')] = p; });
  var STEP_TEXT = {
    1:'',
    2:'Step 2 of 4 \u00b7 Pick your salt',
    3:'Step 3 of 4 \u00b7 Delivery or pickup',
    4:'Step 4 of 4 \u00b7 A rep calls you back',
    5:'Request received. A rep calls you back.'
  };
  /* The name sent with the lead is the name shown on the salt's card (Home page field), so a renamed product follows
     through to the quote email and the CRM; these are the fallbacks for a card without one. */
  var SALT_NAMES = {'rock':'Aden Rock Salt', 'one-pass':'OnePass™ Treated Salt'};
  Array.prototype.forEach.call(root.querySelectorAll('.hq-choice--pick[data-v]'), function(c){
    var b = c.querySelector('.hq-ct b'), t = b ? b.textContent.replace(/\s+/g, ' ').trim() : '';
    if(t && SALT_NAMES.hasOwnProperty(c.getAttribute('data-v'))) SALT_NAMES[c.getAttribute('data-v')] = t;
  });
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var step = 1, busy = false, fulfillment = '', tons = '';
  var SALT_ORDER = ['rock', 'one-pass'], picked = {};
  function productList(){ return SALT_ORDER.filter(function(k){ return picked[k]; }).map(function(k){ return SALT_NAMES[k]; }).join(', '); }
  var contact = panels[4] ? panels[4].querySelector('[data-role="contact"]') : null;
  var addrWrap = contact ? contact.querySelector('[data-role="addr"]') : null;
  /* ---------- lead post (theme REST route) ---------- */
  function utm(){
    var q = new URLSearchParams(location.search), out = {};
    ['source', 'medium', 'campaign', 'term', 'content'].forEach(function(k){ out['utm_' + k] = q.get('utm_' + k) || ''; });
    return out;
  }
  function place(z){
    var r = zipCache[z];
    return r && r.city && r.state_code ? r.city + ', ' + r.state_code + ' ' + z : z;
  }
  function lead(partial, extra){
    var z = /^\d{5}$/.test(input.value) ? input.value : '';
    return Object.assign({zip:z, address:place(z), fulfillment:fulfillment, product:productList(), tonnage:tons, partial:partial}, extra || {}, utm());
  }
  /* WordPress port: two bot checks the server makes (lead.php, adensalt_lead_screen). `hp` is the value of an input
     no person sees or reaches (.hq-hp in hero.php). `ticket` is what the server answered the first step post with;
     it is sent back so the server knows an earlier step happened here, and when. Neither is forwarded to the CRM. */
  var ticket = '';
  var hpInput = root.querySelector('.hq-hp input');
  function post(payload){
    if(!window.fetch) return Promise.resolve({ok:true, skipped:true});
    return fetch(restUrl() + 'lead', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(Object.assign({hp:hpInput ? hpInput.value : '', ticket:ticket}, payload))})
      .then(function(r){
        var ok = r.ok;
        return r.json().then(function(j){
          if(!ticket && j && typeof j.ticket === 'string') ticket = j.ticket;
          return {ok:ok};
        }, function(){ return {ok:ok}; });
      })
      .catch(function(){ return {ok:false}; });
  }
  function mapChoice(){
    root.classList.toggle('is-deliver', step > 1 && fulfillment === 'delivery');
    root.classList.toggle('is-pickup', step > 1 && fulfillment === 'pickup');
  }
  function focusIn(panel){
    var t = panel.getAttribute('role') === 'status' ? panel : panel.querySelector('.hq-h');
    if(t){ try{ t.focus({preventScroll:true}); }catch(err){ t.focus(); } }
  }
  function go(n){
    if(busy || n === step) return;
    var from = panels[step], to = panels[n];
    var animate = !reduce;
    var h0 = shell.getBoundingClientRect().height;
    step = n;
    from.hidden = true;
    to.hidden = false;
    root.classList.toggle('is-flow', n > 1);
    mapChoice();
    stepText.innerHTML = n === 1 ? zipLine() : STEP_TEXT[n];
    stepText.classList.toggle('is-zip', n === 1 && (zipState === 'in' || zipState === 'out'));
    stepText.classList.toggle('is-err', n === 1 && zipState === 'err');
    if(n === 4) addrWrap.hidden = fulfillment !== 'delivery';
    if(!reduce){
      to.classList.add('entering');
      void to.offsetHeight;
      requestAnimationFrame(function(){ to.classList.remove('entering'); });
    }
    if(animate){
      busy = true;
      var h1 = shell.getBoundingClientRect().height;
      shell.style.height = h0 + 'px';
      void shell.offsetHeight;
      var done = false;
      var release = function(){
        if(done) return; done = true;
        shell.removeEventListener('transitionend', onEnd);
        shell.style.height = '';
        busy = false;
        yardLayout();
      };
      var onEnd = function(e){ if(e.target === shell && e.propertyName === 'height') release(); };
      shell.addEventListener('transitionend', onEnd);
      setTimeout(release, 500);
      requestAnimationFrame(function(){ shell.style.height = h1 + 'px'; });
    }else{
      yardLayout();
    }
    focusIn(to);
  }
  /* Step 2's product photos sit in a hidden panel: warm them on the ZIP field's first focus (and again on a
     valid ZIP), so they are loaded and decoded before step 2 shows */
  var photosWarm = false;
  function warmSaltPhotos(){
    if(photosWarm || !panels[2]) return;
    photosWarm = true;
    all(panels[2], '.hq-photo img').forEach(function(img){
      img.loading = 'eager';
      var pre = new Image();
      pre.src = img.getAttribute('src');
      if(pre.decode) pre.decode().catch(function(){});
    });
  }
  input.addEventListener('focus', warmSaltPhotos, {once:true});
  /* Step 1: the bar */
  if(!single) form.addEventListener('submit', function(e){
    e.preventDefault();
    if(!/^\d{5}$/.test(input.value)){ setZip('err'); input.focus(); return; }
    warmSaltPhotos();
    if(zipState === 'err') setZip('');
    lookup(input.value);
    post(lead('address'));
    go(2);
  });
  /* Radio cards: arrows move focus, a click (or Enter or Space) picks */
  function radios(list, onPick){
    function mark(v){
      list.forEach(function(c){ c.setAttribute('aria-checked', c.getAttribute('data-v') === v ? 'true' : 'false'); });
      var cur = list.filter(function(c){ return c.getAttribute('data-v') === v; })[0] || list[0];
      list.forEach(function(c){ c.setAttribute('tabindex', c === cur ? '0' : '-1'); });
    }
    list.forEach(function(c, i){
      c.addEventListener('click', function(){ if(!busy) onPick(c.getAttribute('data-v'), mark); });
      c.addEventListener('keydown', function(e){
        var k = e.key, to = null;
        if(k === 'ArrowRight' || k === 'ArrowDown') to = list[(i + 1) % list.length];
        else if(k === 'ArrowLeft' || k === 'ArrowUp') to = list[(i - 1 + list.length) % list.length];
        if(!to) return;
        e.preventDefault();
        list.forEach(function(x){ x.setAttribute('tabindex', x === to ? '0' : '-1'); });
        to.focus();
      });
    });
    return mark;
  }
  function all(panel, sel){ return panel ? Array.prototype.slice.call(panel.querySelectorAll(sel)) : []; }
  /* Step 2: salt, one or both. Cards toggle (aria-pressed); Continue enables once one is picked and posts the product(s). */
  var saltCards = all(panels[2], '.hq-choice--pick');
  var cont = panels[2] ? panels[2].querySelector('[data-role="continue"]') : null;
  function syncSalt(){
    saltCards.forEach(function(c){ c.setAttribute('aria-pressed', picked[c.getAttribute('data-v')] ? 'true' : 'false'); });
    if(cont) cont.setAttribute('aria-disabled', productList() ? 'false' : 'true');
  }
  saltCards.forEach(function(c){
    c.addEventListener('click', function(){
      if(busy) return;
      var v = c.getAttribute('data-v');
      picked[v] = !picked[v];
      syncSalt();
    });
  });
  if(cont) cont.addEventListener('click', function(){
    if(busy || step !== 2 || !productList()) return;
    post(lead('product'));
    go(3);
  });
  /* Step 3: deliver or pick up, plus tonnage; moves on once both are picked, in either order, and posts both */
  function howDone(){
    if(!fulfillment || !tons || step !== 3) return;
    busy = true;
    post(lead('fulfillment'));
    setTimeout(function(){ busy = false; go(4); }, 200);
  }
  radios(all(panels[3], '.hq-choice'), function(v, mark){
    if(step !== 3) return;
    fulfillment = v;
    mark(v);
    mapChoice();
    howDone();
  });
  radios(all(panels[3], '.hq-ton'), function(v, mark){ tons = v; mark(v); howDone(); });
  /* Step 4: contact, all three required; the delivery address stays optional. The one screen uses the same checks on
     its own fields, plus the ZIP (in page order, so the first one wrong gets the focus). */
  var fieldScope = single || contact;
  var FIELDS = {
    name:{el:fieldScope.querySelector('[name="name"]'), msg:'Enter your name.', ok:function(v){ return v.trim().length > 0; }},
    phone:{el:fieldScope.querySelector('[name="phone"]'), msg:'Enter a 10-digit phone number.', ok:function(v){ var d = v.replace(/\D+/g, ''); if(d.length === 11 && d[0] === '1') d = d.slice(1); return d.length === 10; }},
    email:{el:fieldScope.querySelector('[name="email"]'), msg:'Enter a valid email address.', ok:function(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); }}
  };
  if(single) FIELDS.zip = {el:input, msg:'Enter a 5-digit ZIP code.', ok:function(v){ return /^\d{5}$/.test(v); }};
  function fieldState(k, show){
    /* the error line is the first id in aria-describedby (the ZIP's also names the nearest-yard line) */
    var f = FIELDS[k], good = f.ok(f.el.value), err = document.getElementById(f.el.getAttribute('aria-describedby').split(' ')[0]);
    if(show || good){
      f.el.setAttribute('aria-invalid', good ? 'false' : 'true');
      err.textContent = good ? '' : f.msg;
      err.hidden = good;
    }
    return good;
  }
  Object.keys(FIELDS).forEach(function(k){
    /* once flagged, a field clears its error as soon as it is fixed */
    FIELDS[k].el.addEventListener('input', function(){ if(FIELDS[k].el.getAttribute('aria-invalid') === 'true') fieldState(k, false); });
  });
  function firstWrong(){
    var first = null;
    Object.keys(FIELDS).forEach(function(k){ if(!fieldState(k, true) && !first) first = FIELDS[k].el; });
    return first;
  }
  function contactOf(){
    return {name:FIELDS.name.el.value.trim(), phone:FIELDS.phone.el.value.trim(), email:FIELDS.email.el.value.trim()};
  }
  function nearestYard(z){ return zipState === 'in' && zipInfo && zipInfo.k === z ? YARD_NAMES[zipInfo.near[0]] : ''; }
  /* After the final post: on success tell the Aden Tracking plugin a quote was accepted. It fires whichever conversions are
     set up in wp-admin → Tracking & Scripts (Analytics, Google Ads, Meta, LinkedIn). No personal details are passed. The
     label tells the two forms apart in Analytics; `form` stays 'quote', so Google Ads counts the same conversion. */
  function sent(r, label, payload){
    if(r.ok){
      try{ document.dispatchEvent(new CustomEvent('aden:lead', {detail:{form:'quote', params:{event_category:'Salt Landing Page', event_label:label}}})); }catch(err){}
      handoff(payload); return;
    }
    var p = document.createElement('p');
    p.className = 'hq-fallback';
    p.innerHTML = 'If you don\u2019t hear from us, call ' + PHONE_A + '.';
    panels[5].querySelector('.panel-body').appendChild(p);
  }
  if(contact) contact.addEventListener('submit', function(e){
    e.preventDefault();
    if(busy) return;
    var first = firstWrong();
    if(first){ first.focus(); return; }
    var street = fulfillment === 'delivery' ? addrWrap.querySelector('input').value.trim() : '';
    var payload = lead(false, contactOf());
    if(street) payload.address = street;
    /* WordPress port, additive: the typed street and the nearest yard as their own keys (GF fields "street" / "nearest_yard"); address is unchanged */
    payload.street = street;
    payload.nearest_yard = nearestYard(payload.zip);
    go(5);
    post(payload).then(function(r){ sent(r, 'Multi-step form final submit', payload); });
  });
  /* ---------- WordPress addition (2026-10-15): the one-screen form ----------
     Name, phone, email and ZIP are required, tons optional; nothing is posted before Get my price. The time-trap ticket
     comes with the page (data-ticket), since no step post comes first. The ZIP still lights the map and names the
     nearest yard as it is typed; on submit the lookup gets a moment (at most 1.5 s) to finish, so the lead carries the
     town and the yard. A salt chosen with a product card's button travels as the lead's product. The quote has the same
     keys as the steps' final lead: fulfillment and street are empty. */
  if(single){
    ticket = single.getAttribute('data-ticket') || '';
    var tonsSelect = single.querySelector('select[name="tons"]');
    var sending = false;
    /* The lookup's answer is applied before sending even when it came back earlier for a value since changed (a ZIP filled
       without an input event): applyZip only takes the answer for the ZIP in the box, and does nothing twice. */
    var zipSettled = function(z){
      return new Promise(function(done){
        lookup(z);
        var t0 = Date.now();
        (function wait(){
          if(z in zipCache){ applyZip(z, zipCache[z]); done(); }
          else if(!window.fetch || Date.now() - t0 > 1500) done();
          else setTimeout(wait, 100);
        })();
      });
    };
    /* Some browsers fill a field without an input event (Safari's AutoFill has been one). The ZIP is tidied on change and
       again on submit, so a filled ZIP+4 ("10986-1234") is never refused. */
    var tidyZip = function(){
      if(/^\d{5}$/.test(input.value)) return;
      input.dispatchEvent(new Event('input', {bubbles:true}));
    };
    input.addEventListener('change', tidyZip);
    single.addEventListener('submit', function(e){
      e.preventDefault();
      if(sending || step !== 1) return;
      tidyZip();
      var first = firstWrong();
      if(first){ first.focus(); return; }
      sending = true;
      zipSettled(input.value).then(function(){
        tons = tonsSelect ? tonsSelect.value : '';
        var payload = lead(false, contactOf());
        payload.street = '';
        payload.nearest_yard = nearestYard(payload.zip);
        go(5);
        post(payload).then(function(r){ sent(r, 'Single-step form final submit', payload); });
      });
    });
    /* See our salt: a plain link to #products, scrolled smoothly (at once with reduced motion); the products heading
       takes the focus so keyboard and screen reader users continue from there. */
    var more = single.querySelector('.hq-more');
    if(more) more.addEventListener('click', function(e){
      var to = document.getElementById('products');
      if(!to) return;
      e.preventDefault();
      to.scrollIntoView({behavior:reduce ? 'auto' : 'smooth', block:'start'});
      var h = to.querySelector('h2, h1') || to;
      if(!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
      try{ h.focus({preventScroll:true}); }catch(err){}
    });
  }
  /* ---------- WordPress addition: pickup quote -> customer account form ----------
     Not in the original funnel. Once the server has accepted a PICKUP quote, the confirmation counts down and
     takes the visitor to the customer account form. Off unless hero.php prints data-account (Site Settings
     switch on, account page published, its form active).
     - Their answers are handed over in sessionStorage: this tab only, never in the address, never sent anywhere
       by this script. The item is written only at the moment they leave for the form (at zero, or on Continue),
       so Stay leaves nothing behind; 90-account-form.js reads it there and deletes it.
     - The tick runs only while the tab is visible, the block is on screen and no control in it has focus.
       Stay or Escape cancels and leaves the Continue link. */
  var ACCT = null, ACCT_KEY = 'adensaltAccountPrefill';
  try{ ACCT = JSON.parse(root.getAttribute('data-account') || 'null'); }catch(err){ ACCT = null; }
  /* nothing is kept between visits: drop anything an earlier quote in this tab left */
  try{ sessionStorage.removeItem(ACCT_KEY); }catch(err){}
  function handoff(payload){
    if(!ACCT || !ACCT.url || payload.fulfillment !== 'pickup') return;
    var place = zipCache[payload.zip] || {};
    var details = {
      name:payload.name, phone:payload.phone, email:payload.email, zip:payload.zip,
      city:place.city || '', state:place.state_code || '', county:place.county || '',
      product:payload.product, tonnage:payload.tonnage, fulfillment:payload.fulfillment, nearest_yard:payload.nearest_yard
    };
    function stash(){
      try{ sessionStorage.setItem(ACCT_KEY, JSON.stringify(Object.assign({at:Date.now()}, details))); }
      catch(err){ /* no storage (some private modes): the form simply opens empty */ }
    }
    var total = Math.min(60, Math.max(5, parseInt(ACCT.seconds, 10) || 10)), left = total;
    var timer = null, inView = true, held = false, watcher = null;
    var many = String(ACCT.count || 'Taking you to account setup in %s seconds.');
    var one = String(ACCT.count_one || many);
    var box = document.createElement('div');
    box.className = 'hq-next';
    box.innerHTML =
      '<p class="hq-next__t">' + esc(ACCT.title) + '</p>' +
      '<p class="hq-next__s">' + esc(ACCT.text) + '</p>' +
      '<div class="hq-next__bar" aria-hidden="true"><span></span></div>' +
      '<p class="hq-next__c"><span class="hq-next__sr">' + esc(String(ACCT.sr || many).replace('%s', total)) + '</span>' +
        '<span class="hq-next__n" aria-hidden="true"></span></p>' +
      '<div class="hq-next__a"><a class="hq-btn hq-next__go" href="' + esc(ACCT.url) + '">' + esc(ACCT.go) + '</a>' +
        '<button type="button" class="hq-next__stay">' + esc(ACCT.stay) + '</button></div>';
    var line = box.querySelector('.hq-next__n'), bar = box.querySelector('.hq-next__bar span');
    var goLink = box.querySelector('.hq-next__go'), stayBtn = box.querySelector('.hq-next__stay');
    function paint(){
      line.innerHTML = esc(left === 1 ? one : many).replace('%s', '<b>' + left + '</b>');
      bar.style.width = Math.min(100, (total - left + 1) / total * 100) + '%';
    }
    function stop(stayed){
      if(timer){ clearInterval(timer); timer = null; }
      if(watcher){ watcher.disconnect(); watcher = null; }
      document.removeEventListener('keydown', onKey);
      if(!stayed || box.classList.contains('is-stopped')) return;
      var hadFocus = document.activeElement === stayBtn;
      box.classList.add('is-stopped');
      box.querySelector('.hq-next__c').textContent = ACCT.stopped || '';
      if(stayBtn.parentNode) stayBtn.parentNode.removeChild(stayBtn);
      if(hadFocus){ try{ goLink.focus({preventScroll:true}); }catch(err){ goLink.focus(); } }
    }
    function leave(){ stop(false); stash(); window.location.assign(ACCT.url); }
    function onKey(e){ if(e.key === 'Escape') stop(true); }
    stayBtn.addEventListener('click', function(){ stop(true); });
    goLink.addEventListener('click', function(e){
      /* another tab or window cannot read this tab's hand-over: stop here and let that one open empty */
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0){ stop(true); return; }
      stop(false); stash();
    });
    box.addEventListener('focusin', function(){ held = true; });
    box.addEventListener('focusout', function(){ held = false; });
    document.addEventListener('keydown', onKey);
    /* back from the account form with this page restored as it was left: show it stopped, not stuck at 1 */
    window.addEventListener('pageshow', function(e){ if(e.persisted) stop(true); });
    panels[5].querySelector('.panel-body').appendChild(box);
    paint();
    if('IntersectionObserver' in window){
      inView = false;
      watcher = new IntersectionObserver(function(entries){ inView = entries[entries.length - 1].intersectionRatio >= 0.6; }, {threshold:[0, 0.6, 1]});
      watcher.observe(box);
    }
    timer = setInterval(function(){
      if(document.visibilityState === 'hidden' || !inView || held) return;
      left -= 1;
      if(left <= 0){ leave(); return; }
      paint();
    }, 1000);
  }
  /* Back */
  shell.querySelectorAll('[data-role="back"]').forEach(function(b){
    b.addEventListener('click', function(){ go(step - 1); });
  });
  /* Other "Get my price" buttons on the page dispatch hvc:open (detail.salt optional): scroll to the form, then
     focus the ZIP field, or the current step once the flow has started. A salt from a product card is preselected. */
  var formWrap = root.querySelector('.form-wrap');
  document.addEventListener('hvc:open', function(e){
    var want = e.detail && SALT_NAMES[e.detail.salt] ? e.detail.salt : '';
    /* the one screen keeps the salt of the last product card used (a header button keeps it as it is) */
    if(want && single){ picked = {}; picked[want] = true; }
    else if(want && step <= 2){ picked[want] = true; syncSalt(); }
    var focusNow = function(){
      var el = input;
      /* the one screen: the first field still empty or wrong, else Full name */
      if(single){ el = null; Object.keys(FIELDS).forEach(function(k){ if(!el && !FIELDS[k].ok(FIELDS[k].el.value)) el = FIELDS[k].el; }); el = el || FIELDS.name.el; }
      if(step === 1){ try{ el.focus({preventScroll:true}); }catch(err){ el.focus(); } }
      else focusIn(panels[step]);
    };
    formWrap.scrollIntoView({behavior:reduce ? 'auto' : 'smooth', block:single ? 'start' : 'center'});
    if(reduce) focusNow();
    else if('onscrollend' in window){
      var done = false, once = function(){ if(done) return; done = true; focusNow(); };
      window.addEventListener('scrollend', once, {once:true});
      /* already in place: no scroll happens, so no scrollend */
      setTimeout(once, 900);
    }else setTimeout(focusNow, 600);
  });
  /* ---------- Delivery arcs ----------
     At rest, a thin ice arc now and then runs from one of the six yards to a point inside a Core or Extended county
     15 to 90 miles away (never the yard's own county), then fades. Yards take turns. At most two show at once, and the
     loop pauses while the tab is hidden or the hero is off screen. A matched ZIP stops the loop (see ZIP result below).
     Clearing the ZIP brings the loop back. Reduced motion: no ambient arcs, and the ZIP result appears at once. */
  var NS = 'http://www.w3.org/2000/svg';
  var arcRM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var ARC_EASE = 'cubic-bezier(.33,1,.68,1)';
  var arcG = null, zmark = null, zipArc = null;
  var ambient = [], ambTimer = null, ambSeen = true, ambOrder = [], ambLast = null, ambSide = 1;
  var yardCounty = {}, unitsPerMile = 1, eligible = [];
  function arcEl(tag, attrs, parent){
    var e = document.createElementNS(NS, tag);
    Object.keys(attrs).forEach(function(k){ e.setAttribute(k, attrs[k]); });
    if(parent) parent.appendChild(e);
    return e;
  }
  function n2(v){ return (+v).toFixed(2); }
  /* screen px per map unit */
  function unitPx(){ var w = map.getBoundingClientRect().width; return w ? w / vb.width : 1; }
  /* quadratic curve whose middle sits `bow` map units off the chord, on `side` (1 or -1) */
  function curve(x1, y1, x2, y2, bow, side){
    var dx = x2 - x1, dy = y2 - y1, len = Math.hypot(dx, dy) || 1;
    var cx = (x1 + x2) / 2 - dy / len * side * bow * 2, cy = (y1 + y2) / 2 + dx / len * side * bow * 2;
    var q = {a:[x1, y1], c:[cx, cy], b:[x2, y2]};
    q.d = 'M' + n2(x1) + ' ' + n2(y1) + ' Q' + n2(cx) + ' ' + n2(cy) + ' ' + n2(x2) + ' ' + n2(y2);
    return q;
  }
  /* ambient loop */
  function nextYard(){
    if(!ambOrder.length){
      ambOrder = D.y.slice();
      for(var i = ambOrder.length - 1; i > 0; i--){ var j = Math.floor(Math.random() * (i + 1)), t = ambOrder[i]; ambOrder[i] = ambOrder[j]; ambOrder[j] = t; }
      if(ambOrder[0] === ambLast) ambOrder.push(ambOrder.shift());
    }
    ambLast = ambOrder.shift();
    return ambLast;
  }
  function pickDest(y){
    var own = yardCounty[y[0]], minU = 15 * unitsPerMile, maxU = 90 * unitsPerMile, u = unitPx(), clearU = 16 / u;
    var rr = root.getBoundingClientRect(), T = toMap(rr, map.getBoundingClientRect()), blocks = copyBoxes(rr);
    var cands = eligible.filter(function(p){
      if(p === own) return false;
      var c = D.c[p.getAttribute('data-f')], d = Math.hypot(c[1] - y[1], c[2] - y[2]);
      return d > minU * .5 && d < maxU * 1.15;
    });
    var pt = svg.createSVGPoint();
    for(var i = 0; i < 60 && cands.length; i++){
      var p = cands[Math.floor(Math.random() * cands.length)], bb = p.getBBox();
      pt.x = bb.x + Math.random() * bb.width; pt.y = bb.y + Math.random() * bb.height;
      if(!p.isPointInFill(pt)) continue;
      var d = Math.hypot(pt.x - y[1], pt.y - y[2]);
      if(d < minU || d > maxU) continue;
      if(D.y.some(function(o){ return Math.hypot(o[1] - pt.x, o[2] - pt.y) < clearU; })) continue;
      var s = T.px(pt.x, pt.y);
      if(s[0] < 8 || s[1] < 8 || s[0] > rr.width - 8 || s[1] > rr.height - 8) continue;
      if(blocks.some(function(b){ return inBox(s[0], s[1], b); })) continue;
      return [pt.x, pt.y];
    }
    return null;
  }
  function ambDrop(item){
    var i = ambient.indexOf(item);
    if(i > -1) ambient.splice(i, 1);
    if(item.g.parentNode) item.g.parentNode.removeChild(item.g);
  }
  function ambSpawn(){
    if(ambient.length >= 2) return;
    var y = null, dest = null;
    for(var k = 0; k < D.y.length && !dest; k++){ y = nextYard(); dest = pickDest(y); }
    if(!dest) return;
    ambSide = -ambSide;
    var u = unitPx(), len = Math.hypot(dest[0] - y[1], dest[1] - y[2]);
    var q = curve(y[1], y[2], dest[0], dest[1], len * (.2 + Math.random() * .05), ambSide);
    var g = arcEl('g', {'class':'hv-c__amb'}, arcG);
    var path = arcEl('path', {'class':'hv-c__arc', d:q.d, pathLength:'1'}, g);
    var ring = arcEl('circle', {'class':'hv-c__arcring', cx:n2(dest[0]), cy:n2(dest[1]), r:n2(2.5 / u)}, g);
    var dot = arcEl('circle', {'class':'hv-c__arcdot', cx:n2(dest[0]), cy:n2(dest[1]), r:n2(2.5 / u)}, g);
    var item = {g:g, anims:[]};
    ambient.push(item);
    item.anims.push(path.animate([{strokeDashoffset:1}, {strokeDashoffset:0}], {duration:1400, easing:ARC_EASE, fill:'both'}));
    item.anims.push(dot.animate([{opacity:0}, {opacity:1}], {duration:260, delay:1200, easing:'ease-out', fill:'both'}));
    item.anims.push(ring.animate([{opacity:.6, transform:'scale(1)'}, {opacity:0, transform:'scale(4.2)'}], {duration:1000, delay:1200, easing:ARC_EASE, fill:'both'}));
    var fade = g.animate([{opacity:1}, {opacity:0}], {duration:800, delay:2200, easing:'ease-in', fill:'both'});
    item.anims.push(fade);
    fade.onfinish = function(){ ambDrop(item); };
  }
  function ambFadeOut(item, ms){
    item.anims.forEach(function(a){ a.onfinish = null; a.pause(); });
    var o = parseFloat(getComputedStyle(item.g).opacity);
    var a = item.g.animate([{opacity:isNaN(o) ? 1 : o}, {opacity:0}], {duration:ms, easing:'ease-out', fill:'forwards'});
    item.anims.push(a);
    a.onfinish = function(){ ambDrop(item); };
  }
  function ambCanRun(){ return !arcRM && !current && ambSeen && !document.hidden; }
  function ambTick(){
    ambTimer = null;
    if(!ambCanRun()) return;
    ambSpawn();
    ambTimer = setTimeout(ambTick, 2500 + Math.random() * 1000);
  }
  function ambPause(){ clearTimeout(ambTimer); ambTimer = null; }
  function ambResume(delay){ if(ambTimer || !ambCanRun()) return; ambTimer = setTimeout(ambTick, delay); }
  /* ---------- ZIP result ----------
     A matched ZIP gets a straight line from the nearest yard, a dot that runs it once, and the place marker. The map
     zooms in up to 1.35x on the yard and the place (viewBox zoom, so strokes and HTML pins keep their size). All six
     yards stay visible: the zoom steps down (to none at all) until every yard dot and its name fits the view.
     Clearing the ZIP zooms back out. */
  var ZOOM = 1.35, BASE = null, BASE_VB = '', ctxSvg = null, outline = [];
  var curView = null, curK = 0, viewAnim = 0, zoomP = null, zipPt = null;
  function setView(v, k){
    var s = n2(v.x) + ' ' + n2(v.y) + ' ' + n2(v.w) + ' ' + n2(v.h);
    svg.setAttribute('viewBox', s);
    ctxSvg.setAttribute('viewBox', s);
    D.y.forEach(function(y){
      var p = pins[y[0]];
      p.style.left = (y[1] - v.x) / v.w * 100 + '%';
      p.style.top = (y[2] - v.y) / v.h * 100 + '%';
    });
    if(zipPt){
      zmark.style.left = (zipPt[0] - v.x) / v.w * 100 + '%';
      zmark.style.top = (zipPt[1] - v.y) / v.h * 100 + '%';
    }
    map.style.setProperty('--mf', n2(k * 18) + 'px');
    curView = v; curK = k;
  }
  function restView(){
    svg.setAttribute('viewBox', BASE_VB);
    ctxSvg.setAttribute('viewBox', BASE_VB);
    D.y.forEach(function(y){ pins[y[0]].style.left = ''; pins[y[0]].style.top = ''; });
    map.style.removeProperty('--mf');
    root.classList.remove('is-zoom');
    curView = BASE; curK = 0;
  }
  function clampTo(v, lo, hi){ return lo > hi ? (lo + hi) / 2 : Math.max(lo, Math.min(hi, v)); }
  /* the zoomed view: centred on the midpoint of yard and place, then clamped so both sit comfortably in view, the map
     still covers its box, and (desktop) no part of the territory slides under the copy */
  function zoomTarget(p){
    for(var s = ZOOM; s > 1.001; s = Math.round((s - .05) * 100) / 100){ var v = zoomFit(p, s); if(v) return v; }
    return BASE;
  }
  /* name extents around each yard dot, in px (HTML type does not scale with the zoom); a name can flip sides later
     (yardLayout), so each side gets the larger of the two */
  function yardPads(){
    var out = {};
    Object.keys(pins).forEach(function(k){
      var p = pins[k], c = p.getBoundingClientRect(), n = p.querySelector('.hv-c__name').getBoundingClientRect();
      var main = p.classList.contains('hv-c__pin--main');
      var wN = Math.max(n.right - c.left, c.left - n.left, 0) + 8, hN = Math.max(n.height / 2, 12) + 8;
      out[k] = main ? {l:28, r:wN, t:hN + 12, b:hN + 12} : {l:wN, r:wN, t:hN, b:hN};
    });
    return out;
  }
  function zoomFit(p, s){
    var rr = root.getBoundingClientRect(), mr = map.getBoundingClientRect();
    var w = mr.width, h = mr.height, k = w / BASE.w, offX = mr.left - rr.left, offY = mr.top - rr.top;
    var desk = getComputedStyle(map).position === 'absolute';
    var ax = (p.near[1] - BASE.x) * k, ay = (p.near[2] - BASE.y) * k, bx = (p.x - BASE.x) * k, by = (p.y - BASE.y) * k;
    var tx = (ax + bx) / 2 * (1 - s), ty = (ay + by) / 2 * (1 - s);
    tx = clampTo(tx, w * (1 - s), 0); ty = clampTo(ty, h * (1 - s), 0);
    var m = desk ? 48 : 28, L = m, R = w - m, T = m, B = h - m;
    if(desk){
      T = Math.max(T, (parseFloat(getComputedStyle(root).getPropertyValue('--hdr')) || 0) + 40 - offY);
      B = Math.min(B, rr.height - 72 - offY);
      R = Math.min(R, rr.width - 48 - offX - (p.near[0] === 'tc' ? 200 : 0));
    }
    tx = clampTo(tx, L - s * Math.min(ax, bx), R - s * Math.max(ax, bx));
    ty = clampTo(ty, T - s * Math.min(ay, by), B - s * Math.max(ay, by));
    /* every yard dot and its name must stay in view (all six are shown on a ZIP result) */
    var pads = yardPads(), xlo = -Infinity, xhi = Infinity, ylo = -Infinity, yhi = Infinity;
    if(!desk){ L = 8; R = w - 8; T = 8; B = h - 8; }
    D.y.forEach(function(y){
      var X = (y[1] - BASE.x) * k, Y = (y[2] - BASE.y) * k, q = pads[y[0]];
      xlo = Math.max(xlo, L + q.l - s * X); xhi = Math.min(xhi, R - q.r - s * X);
      ylo = Math.max(ylo, T + q.t - s * Y); yhi = Math.min(yhi, B - q.b - s * Y);
    });
    if(xlo > xhi || ylo > yhi) return null;
    tx = Math.max(xlo, Math.min(xhi, tx)); ty = Math.max(ylo, Math.min(yhi, ty));
    if(tx < w * (1 - s) || tx > 0 || ty < h * (1 - s) || ty > 0) return null;
    if(desk){
      var lo = -Infinity, blocks = copyBoxes(rr).filter(function(b){ return b[2] < offX + w / 2; });
      outline.forEach(function(q){
        var X = (q[0] - BASE.x) * k, Y = ty + s * (q[1] - BASE.y) * k + offY;
        blocks.forEach(function(b){ if(Y > b[1] && Y < b[3]) lo = Math.max(lo, b[2] + 12 - offX - s * X); });
      });
      if(tx < lo) tx = lo;
      if(tx > xhi || tx > 0) return null;
    }
    return {x:BASE.x - tx / (s * k), y:BASE.y - ty / (s * k), w:BASE.w / s, h:BASE.h / s};
  }
  function zoomTo(target, k1, done){
    cancelAnimationFrame(viewAnim); viewAnim = 0;
    if(k1 > 0) root.classList.add('is-zoom');
    if(arcRM){ setView(target, k1); if(done) done(); relayout(); return; }
    var from = curView, k0 = curK, t0 = null;
    function frame(ts){
      if(t0 === null) t0 = ts;
      var q = Math.min(1, (ts - t0) / 900), e = q < .5 ? 4 * q * q * q : 1 - Math.pow(-2 * q + 2, 3) / 2;
      setView({x:from.x + (target.x - from.x) * e, y:from.y + (target.y - from.y) * e, w:from.w + (target.w - from.w) * e, h:from.h + (target.h - from.h) * e}, k0 + (k1 - k0) * e);
      if(q < 1){ viewAnim = requestAnimationFrame(frame); return; }
      viewAnim = 0;
      if(done) done();
      relayout();
    }
    viewAnim = requestAnimationFrame(frame);
  }
  function arcsResize(){ if(zoomP && !viewAnim){ var zt = zoomTarget(zoomP); setView(zt, zt === BASE ? 0 : 1); } }
  function removeZip(){
    root.classList.remove('is-close');
    if(zmark) zmark.classList.remove('is-on', 'is-still');
    if(!zipArc) return;
    zipArc.dead = true;
    cancelAnimationFrame(zipArc.raf);
    zipArc.anims.forEach(function(a){ a.cancel(); });
    if(zipArc.g.parentNode) zipArc.g.parentNode.removeChild(zipArc.g);
    zipArc = null;
  }
  function settle(still){
    if(!zmark) return;
    zmark.classList.toggle('is-still', !!still);
    void zmark.offsetWidth;
    zmark.classList.add('is-on');
  }
  function arcsZip(p){
    ambPause();
    var fading = ambient.length > 0 && !arcRM;
    ambient.slice().forEach(function(it){ ambFadeOut(it, 300); });
    removeZip();
    zipPt = [p.x, p.y];
    zoomP = p;
    var zt = zoomTarget(p);
    zoomTo(zt, zt === BASE ? 0 : 1);
    var near = p.near, x1 = near[1], y1 = near[2], x2 = p.x, y2 = p.y;
    /* screen px per map unit once zoomed */
    var u = map.getBoundingClientRect().width / zt.w, len = Math.hypot(x2 - x1, y2 - y1), lenPx = len * u;
    /* close to the yard: the yard dot stays small so the place marker (drawn above it) keeps clear */
    root.classList.toggle('is-close', lenPx < 28);
    if(lenPx < 4){ settle(arcRM); return; }
    /* start at the edge of the yard dot, not under it */
    var trim = Math.min(7 / u, len * .3);
    x1 += (x2 - x1) / len * trim; y1 += (y2 - y1) / len * trim;
    var d = 'M' + n2(x1) + ' ' + n2(y1) + ' L' + n2(x2) + ' ' + n2(y2);
    var g = arcEl('g', {'class':'hv-c__zip'}, arcG);
    var cas = arcEl('path', {'class':'hv-c__zcase', d:d, pathLength:'1'}, g);
    var path = arcEl('path', {'class':'hv-c__zarc', d:d, pathLength:'1'}, g);
    var pts = [];
    for(var i = 0; i <= 24; i++) pts.push([x1 + (x2 - x1) * i / 24, y1 + (y2 - y1) * i / 24]);
    var z = zipArc = {g:g, pts:pts, anims:[], raf:0, dead:false};
    if(arcRM){
      cas.style.strokeDashoffset = 0; path.style.strokeDashoffset = 0;
      settle(true);
      return;
    }
    var opts = {duration:800, delay:fading ? 300 : 150, easing:ARC_EASE, fill:'both'};
    z.anims.push(cas.animate([{strokeDashoffset:1}, {strokeDashoffset:0}], opts));
    var draw = path.animate([{strokeDashoffset:1}, {strokeDashoffset:0}], opts);
    z.anims.push(draw);
    draw.onfinish = function(){
      if(z.dead) return;
      var total = path.getTotalLength(), dot = arcEl('circle', {'class':'hv-c__zdot', cx:n2(x1), cy:n2(y1), r:n2(3 / u)}, g), t0 = null;
      function run(ts){
        if(z.dead) return;
        if(t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / 1600), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        var at = path.getPointAtLength(e * total);
        dot.setAttribute('cx', n2(at.x)); dot.setAttribute('cy', n2(at.y)); dot.setAttribute('r', n2(3 / unitPx()));
        if(k < 1){ z.raf = requestAnimationFrame(run); return; }
        settle(false);
        var out = dot.animate([{opacity:1}, {opacity:0}], {duration:240, easing:'ease-out', fill:'forwards'});
        z.anims.push(out);
        out.onfinish = function(){ if(dot.parentNode) dot.parentNode.removeChild(dot); };
      }
      z.raf = requestAnimationFrame(run);
    };
  }
  function arcsClear(){
    removeZip();
    if(zoomP){
      zoomP = null;
      zoomTo(BASE, 0, function(){ zipPt = null; restView(); });
    }
    ambResume(arcRM ? 900 : 1200);
  }
  (function(){
    arcG = arcEl('g', {'class':'hv-c__arcs', 'aria-hidden':'true'});
    svg.insertBefore(arcG, spot);
    zmark = document.createElement('span');
    zmark.className = 'hv-c__zmark';
    root.querySelector('.hv-c__pins').appendChild(zmark);
    ctxSvg = root.querySelector('.hv-c__ctxsvg');
    BASE_VB = svg.getAttribute('viewBox');
    BASE = {x:vb.x, y:vb.y, w:vb.width, h:vb.height};
    curView = BASE;
    /* Core and Extended outline samples (map units), used to keep the zoomed map clear of the copy; the faint border
       counties may slide under its edge */
    paths.forEach(function(p){
      if(p.getAttribute('data-t') === 'edge') return;
      var L = p.getTotalLength();
      for(var d = 0; d < L; d += 8){ var q = p.getPointAtLength(d); outline.push([q.x, q.y]); }
    });
    var sum = 0, cnt = 0;
    D.y.forEach(function(a, i){ D.y.forEach(function(b, j){ if(j > i){ sum += Math.hypot(a[1] - b[1], a[2] - b[2]) / miles(a[3], a[4], b[3], b[4]); cnt++; } }); });
    unitsPerMile = sum / cnt;
    eligible = paths.filter(function(p){ var t = p.getAttribute('data-t'); return t === 'core' || t === 'extended'; });
    var ypt = svg.createSVGPoint();
    D.y.forEach(function(y){
      ypt.x = y[1]; ypt.y = y[2];
      yardCounty[y[0]] = paths.filter(function(p){ return p.isPointInFill(ypt); })[0] || null;
    });
    if(!arcRM){
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          ambSeen = es[es.length - 1].isIntersecting;
          if(ambSeen) ambResume(600); else ambPause();
        }).observe(root);
      }
      document.addEventListener('visibilitychange', function(){ if(document.hidden) ambPause(); else ambResume(600); });
      /* first arc after the map's entrance has settled */
      ambResume(1900);
    }
  })();
})();
